import {makeStyles} from '@material-ui/core';

export default makeStyles((theme) => (
    {
        cont: {
            marginTop: theme.spacing(4)
        }
    }
))